// extracted by mini-css-extract-plugin
export var notificationHost = "_kt-0";